import { render, staticRenderFns } from "./game_n.vue?vue&type=template&id=410cee66&scoped=true"
import script from "./game_n.vue?vue&type=script&lang=js"
export * from "./game_n.vue?vue&type=script&lang=js"
import style0 from "./game_n.vue?vue&type=style&index=0&id=410cee66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410cee66",
  null
  
)

export default component.exports